import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';

/**
 * EmailMarketingLayout — lightweight wrapper for the Email Marketing module.
 * Does NOT render its own sidebar or AppBar because the production
 * dashboard already provides those.  It simply passes through <Outlet />
 * so that child routes (Dashboard, Campaigns, Templates, Subscribers)
 * render inside the main content area of the production layout.
 */
export default function EmailMarketingLayout() {
  return (
    <Box sx={{ width: '100%' }}>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
